import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(0),
  gap: 0,
  backgroundColor: "#fff",
  borderRadius: 8,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  border: "1px solid #f0f0f0",
  overflow: "hidden",
}));

export const BlockTitle = styled("h3")(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  color: "#1a1a1a",
  padding: "20px 24px",
  borderBottom: "1px solid #e0e0e0",
  margin: 0,

  [theme.down("sm")]: {
    fontSize: 16,
    padding: "15px 15px",
  },
}));

export const RoutesWrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 0,
  width: "100%",
}));
